import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, WritableSignal, signal } from '@angular/core';

import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { SidenavService } from '../../shared/sidenav/sidenav.service';
import { ThemeMode, ThemeService } from './services/theme.service';
import { NotificationService } from './services/notification.service';
import { TrustedDevice, TrustedDevicesService } from './services/trusted-devices.service';
import { AlertService } from '../../shared/alert/alert.service';


@Component({
  selector: 'app-settings',
  standalone: false,
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.css'
})
export class SettingsComponent implements OnInit, OnDestroy {

  hideSingle = signal<boolean>(false);
  modeNav!: string // = 'side'
  sizeNav!: string //= 'sidenav'
  theme!: ThemeMode
  notificationStatus!: string
  trustedDevices: TrustedDevice[] = []
  isRevoking = false
  
  constructor(
    private sidenavService: SidenavService,
    private themeService: ThemeService,
    private notificationService: NotificationService,
    private trustedDevicesService: TrustedDevicesService,
    private alert: AlertService
  ){ }

  ngOnInit(): void {
    console.warn('SettingsComponent -> ngOnInit')

    this.loadTrustedDevices()

    this.themeService.mode$().subscribe(mode => this.theme = mode)

    this.notificationService.notificationStatus().subscribe( (b) => {
      console.log('SettingsComponent -> notificationStatus:subscribe', b)
      this.notificationStatus = (b) ? 'on' : 'off'
    })

    //Sidenavc - Mode
    this.sidenavService.sidenavMode().subscribe( (s) => { 
      console.log('SettingsComponent -> sidenavMode:subscribe', s)
      this.modeNav = s
     })
     //Sidenavc - Size
     this.sidenavService.sidenavSize().subscribe( (s) => { 
       console.log('SettingsComponent -> sidenavSize:subscribe', s)
       this.sizeNav = s
      })
  }

  ngOnDestroy(): void {
    console.warn('SettingsComponent -> ngOnDestroy')
  }
  
  onModeChange(s:string){
    console.log('SettingsComponent -> onModeChange', s)

    this.sidenavService.sidenavModeChange(s);    
  }
  
  onSizeChange(s:string){
    console.log('SettingsComponent -> onSizeChange', s)

    this.sidenavService.sidenavSizeChange(s);    
  }

  themeChange(mode: ThemeMode): void {
    this.themeService.setMode(mode);
  }

  async loadTrustedDevices(): Promise<void> {
    try {
      this.trustedDevices = await this.trustedDevicesService.list()
    } catch (error) {
      console.error('SettingsComponent -> loadTrustedDevices', error)
    }
  }

  async revokeDevice(device: TrustedDevice): Promise<void> {
    this.isRevoking = true
    try {
      await this.trustedDevicesService.revoke(device)
      this.alert.show('Device removed', 'phonelink_erase')
      await this.loadTrustedDevices()
    } catch (error) {
      console.error('SettingsComponent -> revokeDevice', error)
      this.alert.show('Remove failed!', 'error')
    } finally {
      this.isRevoking = false
    }
  }

  async revokeAllDevices(): Promise<void> {
    this.isRevoking = true
    try {
      for (const device of this.trustedDevices)
        await this.trustedDevicesService.revoke(device)
      this.alert.show('All devices removed', 'phonelink_erase')
      await this.loadTrustedDevices()
    } catch (error) {
      console.error('SettingsComponent -> revokeAllDevices', error)
      this.alert.show('Remove failed!', 'error')
      await this.loadTrustedDevices()
    } finally {
      this.isRevoking = false
    }
  }

  notificationToggle(): void {
    this.notificationService.notificationToogle();
  }

}
